<template>
  <div>
    <table border="1px" width="600px" cellpadding="0" cellspacing="0" class="vd_table">
      <tr>
        <th class="vd_th"></th>
        <th class="vd_th">金额</th>
      </tr>
      <tr>
        <td class="vd_td_o">利润百分比</td>
        <td class="vd_td_t">
          <el-form-item label-width="0" :prop="'quta_profit_rate'">
            <el-input
              clearable
              maxlength="11"
              @blur="qutaForm.quta_profit_rate = helper.calcPrice(qutaForm.quta_profit_rate, 4, 10000)"
              @input="qutaForm.quta_profit_rate = helper.keepTNum1(qutaForm.quta_profit_rate)"
              v-model="qutaForm.quta_profit_rate"
              show-word-limit
              placeholder="暂无利润百分比"
            ></el-input>
          </el-form-item>
        </td>
      </tr>
      <tr>
        <td class="vd_td_o">样品利润金额</td>
        <td class="vd_td_t">
          <el-form-item label-width="0">
            <el-input maxlength="11" disabled v-model="smpl_price" show-word-limit placeholder="暂无利润百分比"></el-input>
          </el-form-item>
        </td>
      </tr>
      <tr>
        <td class="vd_td_o">含税价格</td>
        <td class="vd_td_t">
          <el-form-item label-width="0">
            <el-input maxlength="11" disabled v-model="priceInd_tax" show-word-limit placeholder="暂无含税价格"></el-input>
          </el-form-item>
        </td>
      </tr>
      <tr>
        <td class="vd_td_o">毛利率</td>
        <td class="vd_td_t">
          <el-form-item label-width="0">
            <el-input maxlength="11" disabled v-model="gross_pro_margin" show-word-limit placeholder="暂无毛利率"></el-input>
          </el-form-item>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';

export default {
  name: 'QutaProfit',
  props: {
    qutaForm: {
      type: Object,
      required: true
    },
    formIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    // 样品利润金额= 含税金额的合计 * 利润百分比
    smpl_price() {
      let temp = new BigNumber(this.qutaForm.tax_price_mtrl).plus(this.qutaForm.tax_price_rate).times(this.qutaForm.quta_profit_rate);
      if (!temp.isFinite()) {
        this.qutaForm.smpl_price = 0.0;
        return 0.0;
      }
      this.qutaForm.smpl_price = temp.toFixed(4, 1);
      return temp.toFixed(4, 1);
    },
    // 含税价格=样品利润金额+含税金额合计
    priceInd_tax() {
      //样品利润金额
      let smpl_price = new BigNumber(this.qutaForm.tax_price_mtrl).plus(this.qutaForm.tax_price_rate).times(this.qutaForm.quta_profit_rate);
      // 配件价格合计
      let quta_part_price_sum = this.qutaForm.assemblyPartsList.reduce((accumulator, currentItem) => {
        return accumulator.plus(new BigNumber(currentItem.quta_part_price || 0));
      }, new BigNumber(0));

      let temp = new BigNumber(smpl_price).plus(this.qutaForm.tax_price_mtrl).plus(this.qutaForm.tax_price_rate).plus(quta_part_price_sum);
      if (!temp.isFinite()) {
        this.qutaForm.priceInd_tax = 0.0;
        return 0.0;
      }
      this.qutaForm.priceInd_tax = temp.toFixed(4, 1);
      return temp.toFixed(4, 1);
    },
    // 毛利率=含税价格/成本价合计
    gross_pro_margin() {
      let temp = new BigNumber(this.qutaForm.priceInd_tax).div(
        new BigNumber(this.qutaForm.cost_price_mtrl).plus(this.qutaForm.cost_price_rate)
      );
      if (!temp.isFinite()) {
        this.qutaForm.gross_pro_margin = 0.0;
        return 0.0;
      }
      this.qutaForm.gross_pro_margin = temp.toFixed(4, 1);
      return temp.toFixed(4, 1);
    }
  },
  data() {
    return {
      tableList: [
        {
          id: 0,
          name: '利润百分比',
          price: ''
        },
        {
          id: 0,
          name: '样品利润金额=含税总金额x利润百分比',
          price: ''
        },
        {
          id: 0,
          name: '含税价格=含税总金额+样品利润金额',
          price: ''
        },
        {
          id: 0,
          name: '毛利率=含税价格/总成本',
          price: ''
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
table .vd_td_t {
  width: 300px;
  height: 30px;
  border-bottom: #e9e9e9 1px solid;
  border-right: #e9e9e9 1px solid;
  border-left: none;
  border-top: none;
}
.vd_td_t:nth-of-type(1) {
  border-top: #e9e9e9 1px solid;
}
table .vd_td_o {
  width: 100px;
  padding-left: 5px;
  color: #606266;
  border-bottom: #e9e9e9 1px solid;
  border-right: #e9e9e9 1px solid;
  border-left: #e9e9e9 1px solid;
  border-top: none;
}
.vd_td_o:nth-of-type(1) {
  border-top: #e9e9e9 1px solid;
}
table {
  // border: #f3f3f3 1px solid;
  border: none;
}
.vd_table {
  margin-top: 20px;
  margin-left: 30px;
}
.vd_th {
  text-align: left;
  height: 30px;
  border-top: #e9e9e9 1px solid;
  background-color: #f5f7fa;
  color: #909399;
  border: none;
}
</style>
